import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { useDispatch, useSelector } from 'react-redux';
import ForecastCategoryMappingTable from '../table/ForecastCategoryMappingTable';
import { getDealStageMappings } from '../../../selectors/wizardSelectors';
import { setDealStageMapping } from '../../../actions/WizardActions';
import Links from '../../../constants/Links';
import { trackWizardInteraction } from '../../../utils/usageTracker';
import { DISABLE_AUTOMATION_ONBOARDING } from '../../../constants/Events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CategoryMapping = ({
  forecastCategories,
  pipelineOptions
}) => {
  const dealStageMappings = useSelector(getDealStageMappings);
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "wizard.map.title"
      })
    }), /*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "wizard.map.body"
      }), "\xA0", /*#__PURE__*/_jsx(KnowledgeBaseButton, {
        url: Links.FORECAST_CATEGORIES_KB
      })]
    }), pipelineOptions.map(({
      text: pipelineName,
      value: pipelineId
    }) => /*#__PURE__*/_jsxs(AccordionItem, {
      defaultOpen: true,
      size: "sm",
      title: pipelineName,
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        marginBlockEnd: "200",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Checkbox, {
            "data-test-id": "automate-button",
            defaultChecked: dealStageMappings[pipelineId].automate,
            marginInlineEnd: "200",
            onChange: event => {
              const checked = event.target.checked;
              if (!checked) {
                trackWizardInteraction('map-categories', DISABLE_AUTOMATION_ONBOARDING);
              }
              dispatch(setDealStageMapping(pipelineId, checked));
            }
          }), /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "wizard.map.automationFlag"
            })
          })]
        }), /*#__PURE__*/_jsx(Text, {
          as: "small",
          marginInlineStart: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "wizard.map.automationHelpText"
          })
        })]
      }), ForecastCategoryMappingTable({
        forecastCategories,
        dealStageMapping: dealStageMappings[pipelineId],
        pipelineId
      })]
    }, pipelineId))]
  });
};
export default CategoryMapping;